import React, { useRef } from 'react';
import './MultiFileInput.scss';
import { Config } from '@/app/config';

const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']);

function getFileUrl(filePath: string): string {
    return `${Config.HOST_URL}/${filePath.replace(/\\/g, '/')}`;
}

function isImage(filePath: string): boolean {
    const ext = filePath.split('.').pop()?.toLowerCase() ?? '';
    return IMAGE_EXTS.has(ext);
}

export interface AttachmentItem {
    id: number;
    file_path: string;
    file_name: string;
    created_at: string;
}

interface MultiFileInputProps {
    attachments: AttachmentItem[];
    onAdd: (file: File) => Promise<void>;
    onRemove: (id: number) => Promise<void>;
    disabled?: boolean;
}

export function MultiFileInput({ attachments, onAdd, onRemove, disabled = false }: MultiFileInputProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;
        for (let i = 0; i < files.length; i++) {
            await onAdd(files[i]);
        }
        e.target.value = '';
    };

    return (
        <div className="multiFileContainer">
            {attachments.map(att => (
                <div key={att.id} className="filePreviewContainer">
                    {isImage(att.file_path) ? (
                        <img
                            src={getFileUrl(att.file_path)}
                            alt={att.file_name}
                            className="previewImage"
                        />
                    ) : (
                        <a
                            href={getFileUrl(att.file_path)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fileIcon"
                            title={att.file_name}
                        >
                            📄
                        </a>
                    )}
                    {!disabled && (
                        <button
                            type="button"
                            className="removeButton"
                            onClick={() => onRemove(att.id)}
                            title="Удалить"
                        >
                            ×
                        </button>
                    )}
                </div>
            ))}
            {!disabled && (
                <label className="fileDropArea">
                    <input
                        ref={inputRef}
                        type="file"
                        multiple
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                    />
                    <div className="uploadPrompt">
                        <p className="text-15 light">+ Добавить файл</p>
                    </div>
                </label>
            )}
        </div>
    );
}
